import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import AddRRHH from "../others/userModule/RRHH/addRRHH";
import EditRRHH from "../others/userModule/RRHH/editRRHH";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_RRHH_MODAL = "addRRHHModal";
const EDIT_RRHH_MODAL = "editRRHHModal";

const RRHH = () => {
  const LavorisInstance = LavorisService.getInstance();
  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHHs, setRRHHs] = useState<any[]>([]);
  const [RRHH, setRRHH] = useState<any>(null);

  const getItem = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias("RRHH");
      setRRHHs(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  }

  useEffect(() => {
    const getData = async () => {
      await getItem()
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_RRHH_MODAL, rowData.id);
    setRRHH(rowData);
  });

  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_RRHH_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={RRHHs}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHHs.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />



      {isActive(ADD_RRHH_MODAL) && (
        <AddRRHH
          show
          urlTittle={ADD_RRHH_MODAL}
          onClose={() => closeModal(ADD_RRHH_MODAL)}
          modalTittle="Agregar RRHH"
          tableLoading={getItem}
        />
      )}
      {isActive(EDIT_RRHH_MODAL) && (
        <EditRRHH
          show
          urlTittle={EDIT_RRHH_MODAL}
          onClose={() => closeModal(EDIT_RRHH_MODAL)}
          modalTittle="Editar RRHH"
          data={RRHH}
          tableLoading={getItem}
        />
      )}
    </>
  );
};

export default RRHH;
